var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWebButtoninline = function SvgWebButtoninline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#576CDB",
    strokeWidth: 1.2,
    clipPath: "url(#web-button_inline_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    d: "M1.25 7.125h17.5"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M11.932 16.5H3.125a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875h13.75c1.036 0 1.875.84 1.875 1.875v4.636"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#576CDB",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    d: "M4.063 4.625a.312.312 0 1 0 0-.625.312.312 0 0 0 0 .625ZM7.188 4.625a.313.313 0 1 0 0-.625.313.313 0 0 0 0 .625Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.933 10v9.25M19.092 11.542c-1.234-.622-4.625-.901-4.625 1.233 0 2.174 4.933 1.236 4.933 3.7 0 2.089-3.525 1.973-4.933 1.233"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "web-button_inline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgWebButtoninline;